export default __webpack_public_path__ + "static/paul-b39e90da268835cf9619d8594283abdc.png";